import styled from 'styled-components';
import Colors from '@/v2/constants/Colors';

export const BurgerButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;

  .icon {
    font-size: 24px;
    color: ${Colors.BLUE};
  }
`;

export const ItemsContainer = styled.div`
  margin: 16px 0;
  display: flex;
  flex-direction: column;
  gap: 32px;

  > a:focus-visible {
    outline: 2px solid ${Colors.BLUE};
    outline-offset: 4px;
  }

  > * {
    cursor: pointer;
  }
`;

export const ButtonsContainer = styled.div`
  margin-top: 32px;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
